<template>
  <MglMap
  style="height: 700px; width: 100%; position: absolute; top :40px; "
    :accessToken="accessToken"
    :mapStyle.sync="mapStyle"
    :scrollZoom="false"
    :center="mapCenter"
    :zoom="defaultZoom"
    @load="onMapLoaded"
    :failIfMajorPerformanceCaveat="true"
  >
    <div id="menu">
      <input id="satellite-v9" type="radio" name="rtoggle" value="satellite" checked="checked" @click="changeMapStyle()">
      <label for="satellite-v9">satellite</label>
      <input id="streets-v11" type="radio" name="rtoggle" value="streets" @click="changeMapStyle()">
      <label for="streets-v11">streets</label>
    </div>
      <MglNavigationControl :showZoom="true" :showCompass="false" />
      <MglGeojsonLayer
     :sourceId="geoJsonSource.data.id"
        :source="geoJsonSource"
        layerId="geocoder"
        :layer="geoJsonLayer"
    />
      <MglGeolocateControl 
        position="top-right" 
        :trackUserLocation="true" 
        :enableHighAccuracy="true" 
        :timeout="6000" 
        :showAccuracyCircle="false"
        :showUserLocation="true"
      />
      <MglMarker
        v-for="item in themes"
        :coordinates="[item.coordinates.lon, item.coordinates.lat]"
        :draggable="false"
        :color.sync="markerColor"
        :key="item.key"
        ref="markers"
      >
        <MglPopup>
          <VCard>
          <div>
            <img :src="item.tileImage" style="width: 200px; height: 150px">
            <span class="text-sm">{{item.title}}</span> <br />
            <button @click="$router.push('/theme/'+item.id)">Aller a l'etape</button>
          </div>
        </VCard>
        </MglPopup>
      </MglMarker>
    </MglMap>
</template>

<script>
import Mapbox from 'mapbox-gl';
import { MglMap, MglNavigationControl, MglMarker, MglPopup, MglGeolocateControl,MglGeojsonLayer } from 'vue-mapbox';
import { mapGetters } from 'vuex'

export default {
  name: 'VisiteMap',
  components: {
    MglMap,
		MglNavigationControl,
		MglMarker,
		MglPopup,
		MglGeolocateControl,
    MglGeojsonLayer
  },
  data () {
    return {
      accessToken: 'pk.eyJ1IjoiZmFsaWxvdSIsImEiOiJja3AzNngzeWgyMWhsMnBtcHZzbDEzNmdoIn0.CRfry0gqZY655_HFO4sAdg',
      defaultZoom: 16,
      mapCenter: [3.474569571524122, 43.582922638708176],
      mapStyle: 'mapbox://styles/mapbox/satellite-v9',
      markerColor: 'white',
      geoJsonSource: {
          type: 'geojson',
          data: {
            id: "thisIsMySource",
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "LineString",
                  coordinates: [
                    [3.476274098251726,43.5844618],[3.4760474515899675,43.584411285050706],
                    [3.4755802460555874,43.58379629707349],[3.475188429411218,43.58389171890092],
                    [3.47492834422487,43.58377182991395],[3.4749030112521906,43.58362992019237],
                    [3.4747797241184086,43.58347822322353],[3.4744402622842863,43.58353939140212],
                    [3.4738677371013837,43.58351981759174],[3.4737748495348253,43.58342194844434],
                    [3.4737639969135437,43.583387943481114],[3.47351307548343,43.582687924767185],
                    [ 3.47341154474881,43.58257201028024],[3.472582510953117,43.58192208385761],
                    [3.473134769758084,43.58157953205465],[3.473241168243386,43.58143027673092],
                    [3.4735873855369803,43.58121006328253],[3.474018046072773,43.5811880418934],
                    [3.4744757284461336,43.581278574219475],[3.474994209954061,43.58159665969128],
                    [3.4752661171943044,43.581841339679755],[ 3.4754935559898614,43.58191925575742],
                    [3.4753725156795667,43.5824261208239],[3.4749857656296212,43.58309897912914],
                    [3.474933410819454,43.58322620967229],[3.4747729686590567,43.58324823031594],
                    [3.4747814129832966,43.58346109612249],[3.4739859576406618,43.58357119883053], 
                    [3.474167318462662,43.58383538602523], [3.4749773213054613,43.583774276630464], 
                    [3.475239095356617,43.583859911641966],[3.475595294758871,43.583761689834944],
                    [3.476285040378571,43.584608200268526],[3.476325060223009,43.58453368658552],
                    ],

                },
                properties: {
                  id: "value0"
                }
              }
            ]
          },
        },
      geoJsonLayer: {
        type: "line",
        paint: {
          'line-color': '#1A73E8',
          'line-width': 4
        },
        layout: {
          'line-join': 'round',
          'line-cap': 'round'
        },
      }
    };
  },
  computed: {
    ...mapGetters({
      themes: 'themes'
    }),
    
    
  },
  methods: {

    changeMapStyle() {
      if (this.mapStyle == 'mapbox://styles/mapbox/satellite-v9') {
        this.mapStyle = 'mapbox://styles/mapbox/streets-v11';
      } else {
        this.mapStyle = 'mapbox://styles/mapbox/satellite-v9';
      }
    },
    created() {
      this.map = null;
      this.mapbox = Mapbox;
      
    },
    onMapLoaded(event) {
      this.map = event.map;
      if (process.env.VUE_APP_APP_NAME == 'fontainebleau_provence') {
        this.mapCenter = [6.109648346900941,43.45769536068693];
        this.geoJsonSource.coordinates == [];
      } else if(process.env.VUE_APP_APP_NAME == 'domaine_dourbie') {
          this.mapCenter = [3.474569571524122, 43.582922638708176]; 
     }

      
},
    
  }
}
</script>

<style lang="scss" scoped>

/deep/ .mapboxgl-user-location-accuracy-circle {
  visibility: hidden !important;
  display: none !important;
}
#menu {
position: absolute;
background: #efefef;
padding: 10px;
font-family: 'Open Sans', sans-serif;
}
.map {
	height: 500px;
}
@media screen and (min-width: 640px) {
	.mapboxgl-ctrl-geocoder {
		width: 100% !important;
		max-width: 100% !important;
	}
}
#app{
  height: 500px; 
  width:100%;
}
#marker{
  width: 40;
}
</style>
